export const LOCAL_DOCTOR_QUEUE_LOOKAHEAD_DAYS = 180;
export const PRODUCTION_DOCTOR_QUEUE_LOOKAHEAD_DAYS = 45;

export function doctorQueueForwardDays(hostname = "") {
  const host = String(hostname || "").toLowerCase();
  if (host === "localhost" || host === "127.0.0.1" || host === "::1") {
    return LOCAL_DOCTOR_QUEUE_LOOKAHEAD_DAYS;
  }
  return PRODUCTION_DOCTOR_QUEUE_LOOKAHEAD_DAYS;
}
